// extracted by mini-css-extract-plugin
module.exports = {"root":"root-3I7xO"};